// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const token = authServices.getToken();

  const [data, setData] = useState([]);
  const fetchSubCommodities = async () => {
    try {
      const response = await apiClient.get(`/api/admin/sub_commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.subCommodity, item])).values()
  );

  const validData = filteredData.filter((item) => item.subCommodity);

  const [data2, setData2] = useState([]);
  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.name, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.name);

  const [LableData, setLableData] = useState({
    subCommodityId: null,
    unitId: null,
  });
  const [formData, setFormData] = useState({

    id: null,
    subSubCommodity: '',
    subCommodityId: null,
    unitId: null,

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************

  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/sub_sub_commodity/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });
        if (response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || null,
            subSubCommodity: response.data.data.subSubCommodity || '',
            subCommodityId: response.data.data.subCommodityId.id || null,
            unitId: response.data.data.unitId.id || null,
          });

          setLableData({
            subCommodityId: response.data.data.subCommodityId.subCommodity || null,
            unitId: response.data.data.unitId.name || null,
          });
          // console.log(response.data.data)

        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };


  //******************************************* Handle save and update the data **************************************************
  const AllData = {
    id: formData.id,
    subCommodityId: {
      id: formData.subCommodityId
    },
    unitId: {
      id: formData.unitId
    },
    subSubCommodity: formData.subSubCommodity,
  }

  // console.log("formData", formData)
  console.log("AllData sdsd", AllData)

  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/sub_sub_commodity/update`, AllData, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };


  useEffect(() => {
    fetchInvoiceData();
    fetchSubCommodities()
    fetchUnit()

  }, [invoiceId, edit]);



  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Sub_Sub_Commodity
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="unit" className="label-custom">Unit</label>
                      <Autocomplete
                        // className={` ${errors.unit ? 'input-error' : ''}`}
                        disablePortal
                        options={validData2} // Full user object
                        getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.unitId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, unitId: value.id }); // Save 'id' in state 
                          } else {
                            setFormData({ ...formData, unitId: "" }); // Reset state 
                          }
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '120px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="subCommodity" className="label-custom">Sub Commodity</label>
                      <Autocomplete
                        // className={` ${errors.subCommodity ? 'input-error' : ''}`}
                        disablePortal
                        options={validData} // Full user object
                        getOptionLabel={(option) => option.subCommodity || ""} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.subCommodityId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, subCommodityId: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, subCommodityId: "" }); // Reset state
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.subCommodity}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '120px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>

                    <div className="spacing w-100 d-inline-block"  >
                      <label htmlFor="subSubCommodity" className="label-custom">Sub Sub Commodity</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="subSubCommodity"
                        name="subSubCommodity"
                        value={formData.subSubCommodity}
                        onChange={handleChange}
                      />

                    </div>
                  </div>


                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
